import { MapPin, Phone, Clock, Mail } from 'lucide-react';

const ContactSection = () => {
  const contactInfo = [
    {
      icon: MapPin,
      title: 'Dirección',
      content: 'Calle Real 109, San Fernando, Cádiz 11100'
    },
    {
      icon: Phone,
      title: 'Teléfono',
      content: '+34 602 704 745 / +34 856 044 420'
    },
    {
      icon: Mail,
      title: 'Email',
      content: 'Tajmahalsafernando@gmail.com'
    },
    {
      icon: Clock,
      title: 'Horario',
      content: 'Lun-Dom: 12:00 - 16:00 y 19:00 - 23:30'
    }
  ];

  return (
    <section 
      id="contacto" 
      className="section-padding bg-[#2D231E]"
      data-testid="contact-section"
    >
      <div className="container-max">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          {/* Left Column - Info */}
          <div>
            <span className="overline text-[#E28743] mb-4 block">Contáctanos</span>
            <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-bold text-[#FDFBF7] mb-6">
              Visítanos o Haz Tu Pedido
            </h2>
            <p className="font-sans text-base md:text-lg text-[#FDFBF7]/80 mb-8">
              Estamos aquí para atenderte. Ven a disfrutar de una experiencia gastronómica 
              única o realiza tu pedido online.
            </p>

            {/* Contact Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {contactInfo.map((item, index) => (
                <div
                  key={index}
                  className="bg-[#FDFBF7]/10 rounded-xl p-5 border border-[#FDFBF7]/20 animate-fade-in-up opacity-0"
                  style={{ 
                    animationDelay: `${index * 100}ms`,
                    animationFillMode: 'forwards'
                  }}
                  data-testid={`contact-${item.title.toLowerCase()}`}
                >
                  <item.icon className="w-6 h-6 text-[#E28743] mb-3" />
                  <h3 className="font-sans font-semibold text-[#FDFBF7] mb-1">
                    {item.title}
                  </h3>
                  <p className="font-sans text-sm text-[#FDFBF7]/70">
                    {item.content}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column - Google Maps embed */}
          <div className="relative rounded-2xl overflow-hidden h-[300px] lg:h-auto min-h-[400px] border border-[#E8DEC8]">
            <iframe
              title="Ubicacion Taj Mahal"
              src="https://www.google.com/maps?q=Calle+Real+109,+San+Fernando,+Cadiz,+Spain&hl=es&z=16&output=embed"
              className="absolute inset-0 w-full h-full"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              data-testid="restaurant-map-iframe"
            />
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Calle+Real+109,+San+Fernando,+Cadiz,+Spain"
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-4 right-4 btn-primary px-4 py-2 text-sm shadow-lg"
              data-testid="view-map-btn"
            >
              <MapPin className="w-4 h-4 inline-block mr-1" /> Como llegar
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
